var _defs, _circle, _g, _g2, _line, _g3, _g4, _g5, _g6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAiConsulting(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "bg-gradient",
    cx: "50%",
    cy: "50%",
    r: "70%",
    fx: "50%",
    fy: "50%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#f0f8ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#d6eaff"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "glow",
    x: "-30%",
    y: "-30%",
    width: "160%",
    height: "160%"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#3498db",
    floodOpacity: 0.3,
    result: "color"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "color",
    in2: "blur",
    operator: "in",
    result: "glow"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic",
    in2: "glow",
    operator: "over"
  })), /*#__PURE__*/React.createElement("animate", {
    xlinkHref: "#brain-circuit",
    attributeName: "opacity",
    values: "0.7;1;0.7",
    dur: "3s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hover-brain-gradient",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#3498db"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "50%",
    stopColor: "#9b59b6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#2c3e50"
  })))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: 60,
    r: 50,
    fill: "url(#bg-gradient)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(30, 40)"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "head-gradient",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#3498db"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#2980b9"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 10,
    fill: "url(#head-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15,25 L15,45 M5,35 L25,35 M15,45 L5,60 M15,45 L25,60",
    stroke: "#3498db",
    strokeWidth: 3,
    strokeLinecap: "round"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(60, 40)",
    id: "brain-circuit",
    filter: "url(#glow)"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "brain-gradient",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#2c3e50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#1a2530"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 30,
    height: 30,
    rx: 5,
    fill: "url(#brain-gradient)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 5,
    y1: 7,
    x2: 25,
    y2: 7,
    stroke: "#3498db",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "stroke-opacity",
    values: "0.5;1;0.5",
    dur: "2s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("line", {
    x1: 5,
    y1: 15,
    x2: 25,
    y2: 15,
    stroke: "#3498db",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "stroke-opacity",
    values: "0.7;1;0.7",
    dur: "2.5s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("line", {
    x1: 5,
    y1: 23,
    x2: 25,
    y2: 23,
    stroke: "#3498db",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "stroke-opacity",
    values: "0.6;1;0.6",
    dur: "3s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("line", {
    x1: 7,
    y1: 5,
    x2: 7,
    y2: 25,
    stroke: "#3498db",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "stroke-opacity",
    values: "0.8;1;0.8",
    dur: "2.2s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("line", {
    x1: 15,
    y1: 5,
    x2: 15,
    y2: 25,
    stroke: "#3498db",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "stroke-opacity",
    values: "0.5;1;0.5",
    dur: "2.7s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("line", {
    x1: 23,
    y1: 5,
    x2: 23,
    y2: 25,
    stroke: "#3498db",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "stroke-opacity",
    values: "0.7;1;0.7",
    dur: "3.2s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 7,
    cy: 7,
    r: 2,
    fill: "#3498db"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "r",
    values: "1.5;2.2;1.5",
    dur: "2s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 7,
    r: 2,
    fill: "#3498db"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "r",
    values: "1.5;2.2;1.5",
    dur: "2.3s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 23,
    cy: 7,
    r: 2,
    fill: "#3498db"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "r",
    values: "1.5;2.2;1.5",
    dur: "2.6s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 7,
    cy: 15,
    r: 2,
    fill: "#3498db"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "r",
    values: "1.5;2.2;1.5",
    dur: "2.9s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 2,
    fill: "#3498db"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "r",
    values: "1.5;2.2;1.5",
    dur: "3.2s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 23,
    cy: 15,
    r: 2,
    fill: "#3498db"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "r",
    values: "1.5;2.2;1.5",
    dur: "3.5s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 7,
    cy: 23,
    r: 2,
    fill: "#3498db"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "r",
    values: "1.5;2.2;1.5",
    dur: "3.8s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 23,
    r: 2,
    fill: "#3498db"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "r",
    values: "1.5;2.2;1.5",
    dur: "4.1s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 23,
    cy: 23,
    r: 2,
    fill: "#3498db"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "r",
    values: "1.5;2.2;1.5",
    dur: "4.4s",
    repeatCount: "indefinite"
  })))), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 55,
    y1: 55,
    x2: 65,
    y2: 55,
    stroke: "#3498db",
    strokeWidth: 2,
    strokeDasharray: "3,2"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "stroke-dashoffset",
    values: "0;10",
    dur: "1s",
    repeatCount: "indefinite"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(55, 25)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 5,
    cy: 5,
    r: 10,
    fill: "none",
    stroke: "#2c3e50",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "rotate",
    from: "0 5 5",
    to: "360 5 5",
    dur: "20s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M5,0 L5,10 M0,5 L10,5",
    stroke: "#2c3e50",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "rotate",
    from: "0 5 5",
    to: "360 5 5",
    dur: "20s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M2,2 L8,8 M2,8 L8,2",
    stroke: "#2c3e50",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "rotate",
    from: "0 5 5",
    to: "360 5 5",
    dur: "20s",
    repeatCount: "indefinite"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60,60 L90,30",
    stroke: "#3498db",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60,60 L90,60",
    stroke: "#3498db",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60,60 L90,90",
    stroke: "#3498db",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60,60 L30,90",
    stroke: "#3498db",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60,60 L30,60",
    stroke: "#3498db",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60,60 L30,30",
    stroke: "#3498db",
    strokeWidth: 1
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M20,20 L25,20 M22.5,17.5 L22.5,22.5",
    stroke: "#3498db",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "0;1;0",
    dur: "2s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M90,35 L95,35 M92.5,32.5 L92.5,37.5",
    stroke: "#3498db",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "0;1;0",
    dur: "3s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M80,85 L85,85 M82.5,82.5 L82.5,87.5",
    stroke: "#3498db",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "0;1;0",
    dur: "2.5s",
    repeatCount: "indefinite"
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    className: "hover-graph",
    opacity: 0
  }, /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 10,
    width: 100,
    height: 80,
    rx: 5,
    fill: "rgba(255,255,255,0.9)",
    stroke: "#3498db",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(60, 55)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 10,
    fill: "url(#hover-brain-gradient)"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "r",
    values: "9;10;9",
    dur: "2s",
    begin: "0s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: -25,
    cy: -15,
    r: 6,
    fill: "#3498db"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "r",
    values: "5.5;6;5.5",
    dur: "2s",
    begin: "0.2s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-25,-15 L0,0",
    stroke: "#3498db",
    strokeWidth: 2,
    strokeDasharray: "1,1"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "stroke-dashoffset",
    values: "0;4",
    dur: "1s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: -15,
    r: 6,
    fill: "#9b59b6"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "r",
    values: "5.5;6;5.5",
    dur: "2s",
    begin: "0.4s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M25,-15 L0,0",
    stroke: "#9b59b6",
    strokeWidth: 2,
    strokeDasharray: "1,1"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "stroke-dashoffset",
    values: "0;4",
    dur: "1s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: -25,
    cy: 15,
    r: 6,
    fill: "#2c3e50"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "r",
    values: "5.5;6;5.5",
    dur: "2s",
    begin: "0.6s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-25,15 L0,0",
    stroke: "#2c3e50",
    strokeWidth: 2,
    strokeDasharray: "1,1"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "stroke-dashoffset",
    values: "0;4",
    dur: "1s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 15,
    r: 6,
    fill: "#e74c3c"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "r",
    values: "5.5;6;5.5",
    dur: "2s",
    begin: "0.8s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M25,15 L0,0",
    stroke: "#e74c3c",
    strokeWidth: 2,
    strokeDasharray: "1,1"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "stroke-dashoffset",
    values: "0;4",
    dur: "1s",
    repeatCount: "indefinite"
  }))), /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 0,
    fill: "none",
    stroke: "#3498db",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "r",
    values: "0;30;0",
    dur: "3s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "stroke-opacity",
    values: "0.8;0;0.8",
    dur: "3s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("g", {
    fontFamily: "Arial",
    fontSize: 6,
    fontWeight: "bold"
  }, /*#__PURE__*/React.createElement("text", {
    x: -25,
    y: -20,
    textAnchor: "middle",
    fill: "#3498db"
  }, "Strategy"), /*#__PURE__*/React.createElement("text", {
    x: 25,
    y: -20,
    textAnchor: "middle",
    fill: "#9b59b6"
  }, "Analysis"), /*#__PURE__*/React.createElement("text", {
    x: -25,
    y: 25,
    textAnchor: "middle",
    fill: "#2c3e50"
  }, "Planning"), /*#__PURE__*/React.createElement("text", {
    x: 25,
    y: 25,
    textAnchor: "middle",
    fill: "#e74c3c"
  }, "Solutions"), /*#__PURE__*/React.createElement("text", {
    x: 0,
    y: 0,
    textAnchor: "middle",
    fill: "#fff",
    fontWeight: "bold"
  }, "AI"))), /*#__PURE__*/React.createElement("text", {
    x: 60,
    y: 22,
    fontFamily: "Arial",
    fontSize: 8,
    fontWeight: "bold",
    fill: "#2c3e50",
    textAnchor: "middle"
  }, "\n      AI Consulting Process\n    "))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAiConsulting);
export default __webpack_public_path__ + "static/media/ai-consulting.2776554aa7d67c1cace464fbd03dab9c.svg";
export { ForwardRef as ReactComponent };